import React from 'react'
import ReactAudioPlayer from 'react-audio-player';

import Viewer360 from './canvas/viewer360/viewer360';
import Sidebar from './canvas/sidebar/sidebar.component';
import TopMenu from './canvas/topMenu/topMenu.component';
import CarMenu from './canvas/individualCarMenu/carMenu.component';
import CarView from './canvas/viewer3D/CarView.component';
import ViewerInterior from './canvas/interiorCar/viewerInteriors';
import FichaBrief from './canvas/fichaTecnica/fichaTecnicaBrief.component';
import FichasComplete from './canvas/fichaTecnica/fichaComplete.component';
import GalleryThumbs from './canvas/gallery/galleryThumbs.component';
import AccessoriesThumbs from './canvas/accesories/accesoriesThumbs.component';
import VideoGallery from './canvas/gallery/videoGallery.component';
import ImageGallery from './canvas/gallery/imageGallery.component';
import Social from './canvas/social/Social.component'
import Info from './canvas/infoScreen/info.component';
import ImageAccesorios from './canvas/accesories/imageAccesorios.component';
import AccesssoriesContainer from './canvas/accessoriesModule/accessoriesContainer.component';
import TermsConditions from './canvas/accessoriesModule/termsConditions.component';
import SurveyBtn from './canvas/survey/survey-btn.component';
import SurveyModal from './canvas/survey/survey-modal.component';

import TopMenuMobile from './canvas/topMenu/topMenuMobile.component';
import SidebarMobile from './canvas/sidebar/mobileComponents/sidebar.component';
import SocialMobile from './canvas/social/SocialMobile.component';
import CarMenuMobile from './canvas/individualCarMenu/carMenuMobile.component';
import FichaBriefMobile from './canvas/fichaTecnica/fichaTecnicaBriefMobile.component';
import GalleryThumbsMobile from './canvas/gallery/galleryThumbsMobile.component';
import ImageGalleryMobile from './canvas/gallery/imageGalleryMobile.component';
import VideoGalleryMobile from './canvas/gallery/videoGalleryMobile.component';
import CarViewMobile from './canvas/viewer3D/CarViewMobile.component';
import AccessoriesThumbsMobile from './canvas/accesories/accessoriesThumbsMobile.component';
import AccessoriesGalleryMobile from './canvas/accesories/imageAccesoriosMobile.component';
import AccessoriesModuleMobile from './canvas/accessoriesModule/accessoriesModuleMobile.component';
import AccessoriesModuleTop from './canvas/accessoriesModule/accessoriesModuleTop.component';
import SurveyBtnMobile from './canvas/survey/survey-btn-mobile.component';
import SurveyModalMobile from './canvas/survey/survey-modal-mobile.component';

import SurveyOverlay from './canvas/experience/overlay.component';
import SurveyPopup from './canvas/experience/popup.component';


import SceneMobile from './canvas/three/sceneMobile.component';
import Scene from './canvas/accesories3D/Scene.component';


import logoford from './../UI/canvas/logo-ford.svg'

import { recorridoData as RData } from '../data/recorrido.data';
import { carData as CData } from '../data/car.data'
import { interiorData as IData } from '../data/interiors.data';
import {colorData} from '../data/colors.data';
import { modelsData } from '../data/models.data'

import handleOpenFullScreen from './../utils/fullscreen'

import song from './../assets/song/song.mp3'

import video from './../assets/video/Ford_intro-Optimizada.mp4'

import calificanos from './../UI/canvas/calificanos.svg'

interface Props{
    isLoading: boolean
    isIntroShowed: boolean
    isMobile: boolean
}

interface State{
    isSidebarOpened: boolean,
    selectedCategory: string,
    selectedFamily: string,
    selectedIndividual: string,
    isCarMenuOpened: boolean,
    contextualMenu: boolean,
    Visor3DActive: boolean,
    VisorInteriors: boolean,
    galleryActive: boolean,
    galleryIndex: number,
    isFichaOpened: boolean,
    isAccesoriosOpened: boolean
    currentIndexCarMenu: number,
    isFichasWebViewActive: boolean,
    btnSelectedIndex: number,
    videoOpened: boolean,
    videoSrc: string,
    imageOpened: boolean,
    imageSrc: string,
    currentPanorama: any,
    currentScene: any,
    currentInterior: any,
    currentInteriorScene: any,
    currentSet: any,
    currentColorsArray: any,
    currentColorIndex: number,
    currentColor: any,
    isFullScreen: boolean,
    currentMultimediaIndex: number,
    currentExtSceneName: string,
    isInfoOpened: boolean,
    currentInfoText: string,
    currentInfoImg: string,
    showLegalNote: boolean,
    isMuted: boolean,
    videoStart: boolean,
    hiddenVideo: boolean,
    showMustangLegalNote: boolean,
    showEscapeLegalNote: boolean,
    showExplorerLegalNote: boolean,
    showBroncoLegalNote: boolean,
    renderEverything: boolean,
    renderFromMenu: boolean,
    currentInteriorPayloaded: string,

    accessoriesImageOpened: boolean,
    accessoriesImageSrc: string,
    currentAccessorieIndex: number,
    accessoriesText: string,
    accessoriesUrl: string,
    showSurvey: boolean,
    showSurveyPopUp: boolean,

    isThreeActive: boolean
    isInterior: boolean,
    currentAccessoriesSelected: any,
    accessoriesMenuMobileOpened: boolean,
    currentColorSelected: any,
    currentIndividualAccessory: any
    termsOpened: boolean,
    isLoading: boolean,

    showFlag: boolean
} 

declare const window: any;
class Canvas extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isSidebarOpened: false,
            selectedCategory: "",
            selectedFamily: "",
            selectedIndividual: "",
            isCarMenuOpened: false,
            contextualMenu: true,
            Visor3DActive: false,
            VisorInteriors: false,
            galleryActive: false,
            galleryIndex: -1,
            isFichaOpened: false,
            isAccesoriosOpened: false,
            currentIndexCarMenu: -1,
            isFichasWebViewActive: false,
            btnSelectedIndex: -1,
            videoOpened: false,
            videoSrc: "",
            imageOpened: false,
            imageSrc: "",
            currentPanorama: RData()[0]["START"].Image,
            currentScene: RData()[0]["START"],
            currentInterior: "",
            currentInteriorScene: {},
            currentSet: [],
            currentColorsArray: [],
            currentColorIndex: -1 ,
            currentColor: "",
            isFullScreen: false,
            currentMultimediaIndex: -1,
            currentExtSceneName: "",
            isInfoOpened: false,
            currentInfoText:"",
            currentInfoImg: "",
            showLegalNote: false,
            isMuted: false,
            videoStart: false,
            hiddenVideo: false,
            showMustangLegalNote: false,
            showEscapeLegalNote: false,
            showExplorerLegalNote: false,
            showBroncoLegalNote: false,
            renderEverything: false,
            renderFromMenu: false,
            currentInteriorPayloaded: "",

            accessoriesImageOpened: false,
            accessoriesImageSrc: "",
            currentAccessorieIndex: -1,
            accessoriesText: "",
            accessoriesUrl: "",

            showSurvey: false,
            showSurveyPopUp: false,

            isThreeActive: false,
            isInterior: false,
            currentAccessoriesSelected: [],
            currentIndividualAccessory: '',
            accessoriesMenuMobileOpened: false,
            currentColorSelected: [],
            termsOpened: false,
            isLoading: false,

            showFlag: true
        }
    }

    componentDidMount(){
        /*let audio = document.getElementById("song") as HTMLAudioElement
        if(audio){
            audio.volume = 0.1
        }*/

        document.getElementById("video")?.addEventListener('ended',this.handleCloseVideo, false)
        let timer = setTimeout(() => {
            this.setState({
                showSurvey: true
            }, () => {clearTimeout(timer)})
        }, 120000)

        setInterval(() => {
            this.setState({
                showFlag: !this.state.showFlag
            })
        }, 30000)
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.isIntroShowed !== this.props.isIntroShowed && !this.props.isIntroShowed && !this.props.isLoading){
            var video: any = document.getElementById('video')
            video.play()
            this.setState({
                videoStart: true
            })
        }
    }

    handleCloseVideo = () => {
        this.setState({
            videoStart: false
        }, () => {
        })
    }

    handleAudio = () => {
        this.setState({
            isMuted: !this.state.isMuted
        },() => {
            setTimeout(() => {
                this.setState({
                    hiddenVideo: true
                })
            }, 100)
            
        })
    }

    handleOpenBar = () => {
        this.setState({
            isFichasWebViewActive: false,
            isSidebarOpened: !this.state.isSidebarOpened,
            contextualMenu: true,
        })
    }

    handleContextualMenu = () => {
        this.setState({
            isFichasWebViewActive: false,
            contextualMenu: !this.state.contextualMenu,
            isSidebarOpened: false
        })
    }

    handleSelectedCategory = (payload: any) => {
        window.paramsObj = {
            "section-hierarchy": payload.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            "section-plain": payload.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            };
            window.ym(88905571, "params", window.paramsObj || {});
            
        this.setState({
            selectedCategory: payload,
            selectedFamily: "",
            //selectedIndividual: ""
        })
    }

    handleSelectedFamily = (payload: any) => {
        console.log("Aca");
        
        let temp_Data: any = RData()[0][payload]
        window.paramsObj = {
            //"section-hierarchy": {this.state.selectedCategory: payload},
            "section-plain": this.state.selectedCategory.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+payload.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            };
            window.ym(88905571, "params", window.paramsObj || {});
        this.setState({
            selectedFamily: payload,
            renderFromMenu: true,
            selectedIndividual: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? payload : this.state.selectedIndividual,
            isCarMenuOpened: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? true:this.state.isCarMenuOpened,
            contextualMenu: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? true:false,
            isSidebarOpened: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? false:true,
            currentExtSceneName: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? payload: "",
            currentPanorama: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? temp_Data.Image: this.state.currentPanorama,
            currentScene: this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? temp_Data: this.state.currentScene,
            currentInteriorPayloaded:this.state.selectedCategory === "PERFORMANCE" || this.state.selectedCategory === "HÍBRIDOS" ? payload:"",
            isFichasWebViewActive: false,
            Visor3DActive: false,
            isFichaOpened: false,
            VisorInteriors: false,
            isThreeActive: false,
            btnSelectedIndex: -1
        })
    }

    handleSelectedIndividual = (payload: any) => {
        window.paramsObj = {
            //"section-hierarchy": {this.state.selectedCategory: payload},
            "section-plain": this.state.selectedCategory.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+this.state.selectedFamily.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+payload.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            };
            window.ym(88905571, "params", window.paramsObj || {});
            
        this.setState({
            selectedIndividual: payload,
            currentInteriorPayloaded: payload,
            renderFromMenu: true,
            isCarMenuOpened: payload !== "" ? true:false,
            contextualMenu: payload !== "" ? true:false,
            isSidebarOpened: payload !== "" ? false:true,
            currentPanorama: RData()[0][payload].Image,
            currentScene: RData()[0][payload],
            isFichasWebViewActive: false,
            Visor3DActive: false,
            isFichaOpened: false,
            VisorInteriors: false,
            btnSelectedIndex: -1,
            currentExtSceneName: payload,
            showLegalNote: payload.includes("EDGE ST") || payload.includes("EDGE SEL"),
            showEscapeLegalNote: (payload.includes("ESCAPE SEL") || payload.includes("ESCAPE TITANIUM"))  && payload.includes("FHEV"),
            showExplorerLegalNote: payload.includes("EXPLORER XLT"),
            showMustangLegalNote: false,
            showBroncoLegalNote: false,
            currentAccessorieIndex: -1,
            accessoriesImageOpened: false,
            accessoriesImageSrc:"",
            isThreeActive: false,
            isAccesoriosOpened: false,
        })
    }

    handleSelectedMenuElement = (index: number, payload: string, indexSubMenu: number) => {
        console.log(index, payload, indexSubMenu)
        if(indexSubMenu === 0 || indexSubMenu === 1){
            var tagElement = 
            payload === 'tecnica' ? "FICHA TÉCNICA":
            payload === 'gallery' ? "GALERÍA":
            payload === 'accesorios' ? "ACCESORIOS":
            payload === 'customize' && indexSubMenu === 0 ? "DETALLE EXTERIOR":
            payload === 'customize' && indexSubMenu === 1 ? "DETALLE INTERIOR":
            payload === 'quotation' ? "COTIZA":""
            window.paramsObj = {
                "section-menus": this.state.selectedIndividual + ">" + tagElement
            };
            window.ym(88905571, "params", window.paramsObj || {})
        }
        if(payload === ''){
            this.setState({
                btnSelectedIndex: -1
            })
        }
        this.setState({
            currentIndexCarMenu: index,
            renderFromMenu: true,
            isFichasWebViewActive: false,
            galleryActive: payload === 'gallery' ? true : false,
            videoOpened: false,
            imageOpened: false,
            imageSrc: "",
            videoSrc: "",
            //btnSelectedIndex: index === -1 && indexSubMenu === -1 ? -1 : this.state.btnSelectedIndex,
            currentAccessorieIndex: -1,
            accessoriesImageOpened: false,
            accessoriesImageSrc:"",
            isAccesoriosOpened: payload === 'accesorios' ? true : false,
            isFichaOpened: payload === 'tecnica' ? true : false,
            Visor3DActive: payload === 'customize' && indexSubMenu === 0 && modelsData()[0][this.state.selectedIndividual] === undefined ? true: false,
            isThreeActive: payload === 'customize' && modelsData()[0][this.state.selectedIndividual] !== undefined ? true : false,
            isInterior: payload === 'customize' && indexSubMenu === 1 ? true: false,
            currentPanorama: payload === 'customize' && indexSubMenu === 1 ? IData()[0][this.state.currentInteriorPayloaded].Image: indexSubMenu === -1 ? RData()[0][this.state.currentExtSceneName].Image: this.state.currentPanorama,
            currentScene: payload === 'customize' && indexSubMenu === 1 ? IData()[0][this.state.currentInteriorPayloaded]: indexSubMenu === -1 ? RData()[0][this.state.currentExtSceneName]: this.state.currentScene,
            showMustangLegalNote: indexSubMenu === -1 ?  false:this.state.showMustangLegalNote,
            showBroncoLegalNote: indexSubMenu === -1 ?  false:this.state.showBroncoLegalNote
        }, () => {
            this.setState({
                currentColor: colorData()[0][this.state.selectedIndividual].Colors[0].Name,
                currentColorsArray: colorData()[0][this.state.selectedIndividual].Colors,
                VisorInteriors: payload === 'customize' && indexSubMenu === 1 ? true: false,
            })
        })
    }

    handleBtnClick = (index: number, payload: string) => {
        this.setState({
            btnSelectedIndex: index
        }, () => {this.handleSelectedMenuElement(this.state.btnSelectedIndex,payload, -1)})
    }

    handleFichaViewOnline = (payoad: boolean) => {
        this.setState({
            isFichasWebViewActive: true
        })
    }

    handleCloseFichas = () => {
        this.setState({
            isFichasWebViewActive: false,
            isFichaOpened: false,
            btnSelectedIndex: -1,
            galleryActive: false,
            videoOpened: false,
        })
    }

    handleCloseGallery = () => {
        this.setState({
            galleryActive: false,
            videoOpened: false,
            btnSelectedIndex: -1,
            imageOpened: false,
            isFichasWebViewActive: false,
            isFichaOpened: false,
            isAccesoriosOpened: false,
            currentAccessorieIndex: -1,
            accessoriesImageOpened: false
        }, () => {
            this.setState({
                imageSrc: "",
                videoSrc: "",
                accessoriesImageSrc:""
            })
        })
    }

    handleOpenVideo = (payload: string, index: number) => {
        this.setState({
            videoOpened: true,
            videoSrc: payload,
            imageOpened: false,
            imageSrc: "",
            currentMultimediaIndex: index,
            isAccesoriosOpened: false,
            currentAccessorieIndex: -1,
            accessoriesImageOpened: false,
            accessoriesImageSrc:""
        })
    }

    handleOpenImage = (payload: string, index: number) => {
        this.setState({
            videoOpened: false,
            videoSrc: "",
            imageOpened: true,
            imageSrc: payload,
            currentMultimediaIndex: index,
            isAccesoriosOpened: false,
            currentAccessorieIndex: -1,
            accessoriesImageOpened: false,
            accessoriesImageSrc:""
        })
    }

    handleOpenAccessoriesImage = (payload: string, index: number, text: string, url: string) => {
        this.setState({
            accessoriesImageOpened: true,
            accessoriesImageSrc: payload,
            currentAccessorieIndex: index,
            accessoriesText: text,
            accessoriesUrl: url
        })
    }

    handleChangePano = (payload: string, renderEverything: boolean) => {
        console.log("Aqua");
        
        this.setState({
            selectedCategory: RData()[0][payload].Category ?  RData()[0][payload].Category : this.state.selectedCategory,
            selectedFamily:  RData()[0][payload].Family ?  RData()[0][payload].Family: this.state.selectedFamily,
            renderFromMenu: false,
            currentPanorama: RData()[0][payload].Image,
            currentScene: RData()[0][payload],
            renderEverything: renderEverything,
            isCarMenuOpened: payload.includes("DIG DER") || payload.includes("DIG IZQ") || payload.includes("LAT DER") || payload.includes("LAT IZQ") || payload.includes("POSTERIOR")
        }, () => {
            if(this.state.renderEverything){
                this.setState({
                    currentExtSceneName: payload,
                    showLegalNote: payload.includes("EDGE ST") || payload.includes("EDGE SEL"),
                    showEscapeLegalNote: (payload.includes("ESCAPE SEL") || payload.includes("ESCAPE TITANIUM"))  && payload.includes("FHEV"),
                    showExplorerLegalNote: payload.includes("EXPLORER XLT"),
                    showMustangLegalNote: false,
                    showBroncoLegalNote: false,
                    selectedIndividual: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? "" : !payload.includes("DIG DER") && !payload.includes("DIG IZQ") && !payload.includes("LAT DER") && !payload.includes("LAT IZQ") && !payload.includes("POSTERIOR") ? payload: this.state.selectedIndividual,
                    isCarMenuOpened: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? false:true,
                    currentInteriorPayloaded: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") || payload.includes("DIG DER") || payload.includes("DIG IZQ") || payload.includes("LAT DER") || payload.includes("LAT IZQ") || payload.includes("POSTERIOR") ? this.state.currentInteriorPayloaded : payload
                })
                if(CData()[0].hasOwnProperty(payload)){
                    this.setState({
                        selectedIndividual: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? "" : payload,
                        isCarMenuOpened: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? false:true,
                    })
                }
                if(!CData()[0].hasOwnProperty(payload)  && !payload.includes("DIG DER") && !payload.includes("DIG IZQ") && !payload.includes("LAT DER") && !payload.includes("LAT IZQ") && !payload.includes("POSTERIOR") && !payload.includes("GENERAL") && !payload.includes("START")){
                    fetch('https://service-umbra-analytics.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/ua/analytics/upload-event', {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ type: "MODELO", value: RData()[0][payload].Family ?  RData()[0][payload].Family: this.state.selectedFamily, session: window.sessionID })
                    })
                        .then(response => response.json())
                        .then(data => {
                            // Aquí puedes utilizar los datos de la respuesta
                            console.log("send");
                        })
                        .catch(error => {
                            // Aquí puedes manejar los errores que puedan ocurrir durante la solicitud
                            console.error(error);
                        });
                }

                if(CData()[0].hasOwnProperty(payload) && !payload.includes("DIG DER") && !payload.includes("DIG IZQ") && !payload.includes("LAT DER") && !payload.includes("LAT IZQ") && !payload.includes("POSTERIOR") && !payload.includes("GENERAL") && !payload.includes("START")){
                    window.paramsObj = {
                        //"section-hierarchy": {this.state.selectedCategory: payload},
                        "section-plain": this.state.selectedCategory.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+this.state.selectedFamily.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+payload.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                        };
                        window.ym(88905571, "params", window.paramsObj || {});

                        fetch('https://service-umbra-analytics.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/ua/analytics/upload-event-child', {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ type: "VERSION", value: this.state.selectedFamily, child: payload, final: null, session: window.sessionID })
                    })
                        .then(response => response.json())
                        .then(data => {
                            // Aquí puedes utilizar los datos de la respuesta
                            console.log("send2");
                        })
                        .catch(error => {
                            // Aquí puedes manejar los errores que puedan ocurrir durante la solicitud
                            console.error(error);
                        });
                }
            }
        })
        
    }

    handleChangeColors = (index: number) => {
        this.setState({
            Visor3DActive: true,
            currentSet: [],
            currentColor: colorData()[0][this.state.selectedIndividual].Colors[index].Name,
            currentColorsArray: colorData()[0][this.state.selectedIndividual].Colors,
            currentColorIndex: index,
            showMustangLegalNote: this.state.selectedIndividual === "MUSTANG MACH 1" && index === 2,
            showBroncoLegalNote: (this.state.selectedIndividual === "BRONCO SPORT WILDTRAK" && index === 2)
        })
    }

    handleCloseSpin = () => {
        this.setState({
            Visor3DActive: false,
            currentColor: "",
            currentColorsArray: [],
            currentColorIndex: -1
        }, () => {
            this.setState({
                currentSet: []
            })
        })
    }

    handleFullScreen = () => {
        this.setState({
            isFullScreen: !this.state.isFullScreen
        })
        handleOpenFullScreen(this.state.isFullScreen)
    }

    handleVehiculosMobile = () => {
        this.setState({
            selectedCategory: "",
            selectedFamily: "",
            selectedIndividual: "",
        })
    }

    handleCategoryMobile = () => {
        this.setState({
            selectedFamily: "",
            selectedIndividual: "",
        })
    }

    handleFamilyMobile = () => {
        this.setState({
            selectedIndividual: "",
        })
    }

    handleOpenInfoScreen = (payload, img, text) => {
        window.paramsObj = {
            //"section-hierarchy": {this.state.selectedCategory: payload},
            "section-plain": this.state.selectedCategory.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+this.state.selectedFamily.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+this.state.selectedIndividual.normalize('NFD').replace(/[\u0300-\u036f]/g,"")+">"+text.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            };
            window.ym(88905571, "params", window.paramsObj || {});
            
        this.setState({
            isInfoOpened: payload,
            currentInfoImg: img,
            currentInfoText: text
        })
    }

    handleOpenSurveyPopup = (payload: boolean, params: boolean = false) => {
        this.setState({
            showSurvey: false,
            showSurveyPopUp: payload
        })
        

        if (!params && !payload) {
        window.paramsObj = {
            "section-qualification": null
        }

        window.ym(88905571, "params", window.paramsObj || {});
        }
    }

    handleSetAccessoriesSelected = (payload: any, accesorySelected: any) => {
        this.setState({
            currentAccessoriesSelected: payload,
            currentIndividualAccessory: accesorySelected === this.state.currentIndividualAccessory ? '':accesorySelected
        })
    }

    handleSetOpenModule = () => {
        this.setState({
            accessoriesMenuMobileOpened: !this.state.accessoriesMenuMobileOpened
        })
    }

    handleSetColor = (payload) => {
        this.setState({
            currentColorSelected: payload
        })
    }

    handleOpenTerms = () => {
        this.setState({
            termsOpened: !this.state.termsOpened
        })
    }

    handleLoad = (payload: boolean) => {
        this.setState({
            isLoading: payload
        })
    }

    handleShowSurvey = () => {
        this.setState({
            showSurvey: !this.state.showSurvey,
            isSidebarOpened: false
        }, () => {
            if(!this.state.showSurvey){
                let timer = setTimeout(() => {
                    this.setState({
                        showSurvey: true
                    }, () => {clearTimeout(timer)})
                }, 120000)
            }
        })
    }

    render(): React.ReactNode {
        return(
            <React.Fragment>
                {
                    !this.props.isIntroShowed && !this.props.isLoading ?
                    <ReactAudioPlayer
                        src={song}
                        autoPlay
                        controls
                        loop
                        muted={this.state.isMuted}
                        id={"song"}
                        volume={0.02}
                    />:null
                }
                {
                    this.props.isMobile ?
                    <div className={!this.props.isIntroShowed && !this.props.isLoading ? 'canvas-main fade-in':'canvas-main fade-out'}>
                        {
                            !this.props.isLoading ?
                            <Viewer360
                                isMobile = {this.props.isMobile} 
                                currentPanorama = { this.state.currentPanorama }
                                currentScene = { this.state.currentScene }
                                handleChangePano = { this.handleChangePano }
                                handleOpenBullet = {this.handleOpenInfoScreen}
                                renderFromMenu = {this.state.renderFromMenu}
                                familia = {this.state.selectedFamily}
                                vehiculo = {this.state.selectedIndividual}
                            />:<></>
                        }
                        
                        <SocialMobile/>
                        {
                            this.state.selectedIndividual ?
                            <CarViewMobile
                                visor3DActive = {this.state.Visor3DActive}
                                individualSelected = {this.state.selectedIndividual}
                                currentColor = {this.state.currentColor}
                                currentSet = {this.state.currentSet}
                                currentColorsArray = {this.state.currentColorsArray}
                                currentColorIndex = {this.state.currentColorIndex}
                                handleChangeColors = {this.handleChangeColors}
                                handleCloseSpin = {this.handleCloseSpin} 
                                showLegalNote = {this.state.showLegalNote}
                            />:null
                        }
                        {this.state.isThreeActive ?
                            <Scene
                                isThreeActive = {this.state.isThreeActive}
                                currentAccessoriesSelected = {this.state.currentAccessoriesSelected}
                                currentColorSelected = {this.state.currentColorSelected}
                                selectedCar = {this.state.selectedIndividual}
                                handleLoad = {this.handleLoad}
                                currentIndividualAccessory = {this.state.currentIndividualAccessory}
                                isMobile={this.props.isMobile}
                                accessoriesMenuMobileOpened = {this.state.accessoriesMenuMobileOpened}
                            />:null
                        }
                        <div className='logo-ford-container-mobile'>
                            <img src={logoford}/>
                        </div>
                        
                        {
                            <SidebarMobile
                                isSidebarOpened={this.state.isSidebarOpened}
                                selectedCategory={this.state.selectedCategory}
                                selectedFamily={this.state.selectedFamily}
                                selectedIndividual={this.state.selectedIndividual}
                                handleSelectedCategory={this.handleSelectedCategory}
                                handleSelectedFamily={this.handleSelectedFamily}
                                handleSelectedIndividual={this.handleSelectedIndividual}
                                handleOpenBar={this.handleOpenBar}
                                handleVehiculosMobile = {this.handleVehiculosMobile}
                                handleCategoryMobile = {this.handleCategoryMobile}
                                handleFamilyMobile = {this.handleFamilyMobile}
                                handleFullScreen={this.handleFullScreen}
                                handleAudio = {this.handleAudio}
                                isMuted = {this.state.isMuted}
                                handleOpenSurvey = {this.handleShowSurvey}
                            />
                        }
                        <FichaBriefMobile
                            isFichaOpened = {this.state.isFichaOpened}
                            handleFichaViewOnline = { this.handleFichaViewOnline }
                            contextualMenu = {this.state.contextualMenu}
                            handleCloseFichas = {this.handleCloseFichas}
                            individualSelected = {this.state.selectedIndividual}
                        />
                        <GalleryThumbsMobile
                            isGalleryThumbsOpened = {this.state.galleryActive}
                            contextualMenu = {this.state.contextualMenu}
                            individualCar = {this.state.selectedIndividual} 
                            handleCloseGallery = {this.handleCloseGallery}
                            openVideo = {this.handleOpenVideo}
                            openImage = {this.handleOpenImage}
                        />
                        <AccessoriesThumbsMobile
                            isGalleryThumbsOpened = {this.state.isAccesoriosOpened}
                            contextualMenu = {this.state.contextualMenu}
                            individualCar = {this.state.selectedIndividual} 
                            handleCloseGallery = {this.handleCloseGallery}
                            openImage = {this.handleOpenAccessoriesImage}
                            currentImageIndex = {this.state.currentAccessorieIndex}
                            isImageOpened = {this.state.accessoriesImageOpened}
                        />
                        <VideoGalleryMobile
                            isVideoOpened = {this.state.videoOpened}
                            VideoSrc = {this.state.videoSrc}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        <ImageGalleryMobile
                            isImageOpened = {this.state.imageOpened}
                            ImageSrc = {this.state.imageSrc}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        <AccessoriesGalleryMobile
                            isImageOpened = {this.state.accessoriesImageOpened}
                            ImageSrc = {this.state.accessoriesImageSrc}
                            currentText = {this.state.accessoriesText}
                            currentUrl = {this.state.accessoriesUrl}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        {
                            this.state.isThreeActive ?
                            <AccessoriesModuleMobile
                                isThreeActive = {this.state.isThreeActive}
                                handleSelectedMenuElement = {this.handleSelectedMenuElement}
                                handleSetAccessoriesSelected = {this.handleSetAccessoriesSelected}
                                currentAccessoriesSelected = {this.state.currentAccessoriesSelected}
                                handleSetOpenModule = {this.handleSetOpenModule}
                                handleSetColor = {this.handleSetColor}
                                handleOpenTerms = {this.handleOpenTerms}
                                carSelected={this.state.selectedIndividual}
                            />:null
                        }
                        {
                            !this.props.isLoading && this.state.isInterior ?
                            <Viewer360
                                currentPanorama = { this.state.currentPanorama }
                                currentScene = { this.state.currentScene }
                                handleChangePano = { this.handleChangePano }
                                handleOpenBullet = {this.handleOpenInfoScreen}
                                renderFromMenu = {this.state.renderFromMenu}
                                familia = {this.state.selectedFamily}
                                vehiculo = {this.state.selectedIndividual}
                            />:<></>
                        }
                        {
                            this.state.isThreeActive ?
                            <AccessoriesModuleTop
                                isThreeActive = {this.state.isThreeActive}
                                handleSelectedMenuElement = {this.handleSelectedMenuElement}
                                isInteror={this.state.isInterior}
                            />:null
                        }
                        {/*<TopMenuMobile/>*/}
                        <CarMenuMobile
                            btnSelectedIndex = {this.state.btnSelectedIndex}
                            handleBtnClick = {this.handleBtnClick}
                            isCarMenuOpened = {this.state.isCarMenuOpened}
                            selectedIndividual = {this.state.selectedIndividual}
                            handleContextualMenu = {this.handleContextualMenu}
                            contextualMenu = {this.state.contextualMenu}
                            handleSelectedMenuElement={this.handleSelectedMenuElement}
                        />
                        <Info 
                            isInfoOpened = {this.state.isInfoOpened}
                            selectedIndividual = {this.state.selectedIndividual}
                            currentInfoImg = {this.state.currentInfoImg}
                            currentInfoText = {this.state.currentInfoText}
                            handleOpenInfoScreen = {this.handleOpenInfoScreen}
                        />
                        {
                            <div className={!this.state.showSurvey && this.state.showFlag ? 'survey-flag-mobile fade-in':'survey-flag-mobile fade-out'}>
                                <img src={calificanos} alt=''></img>
                            </div>
                        }
                        <SurveyBtnMobile
                            handleShowSurvey = {this.handleShowSurvey}
                            showSurvey = {this.state.showSurvey}
                        />
                        <SurveyModalMobile
                            showSurvey = {this.state.showSurvey}
                            handleShowSurvey = {this.handleShowSurvey}
                        />
                    </div>:
                    <div className={!this.props.isIntroShowed && !this.props.isLoading ? 'canvas-main fade-in':'canvas-main fade-out'}>
                        {
                            !this.props.isLoading ?
                            <Viewer360
                                currentPanorama = { this.state.currentPanorama }
                                currentScene = { this.state.currentScene }
                                handleChangePano = { this.handleChangePano }
                                handleOpenBullet = {this.handleOpenInfoScreen}
                                renderFromMenu = {this.state.renderFromMenu}
                                familia = {this.state.selectedFamily}
                                vehiculo = {this.state.selectedIndividual}
                            />:<></>
                        }
                        {
                            this.state.selectedIndividual ?
                            <CarView
                                visor3DActive = {this.state.Visor3DActive}
                                individualSelected = {this.state.selectedIndividual}
                                currentColor = {this.state.currentColor}
                                currentSet = {this.state.currentSet}
                                currentColorsArray = {this.state.currentColorsArray}
                                currentColorIndex = {this.state.currentColorIndex}
                                handleChangeColors = {this.handleChangeColors}
                                handleCloseSpin = {this.handleCloseSpin} 
                            />:null
                        }

                        <FichaBrief
                            isFichaOpened = {this.state.isFichaOpened}
                            handleFichaViewOnline = { this.handleFichaViewOnline }
                            contextualMenu = {this.state.contextualMenu}
                            handleCloseFichas = {this.handleCloseFichas}
                            individualSelected = {this.state.selectedIndividual}
                        />
                        <FichasComplete
                            isFichaViewWebActive = { this.state.isFichasWebViewActive }
                            individualSelected = {this.state.selectedIndividual}
                        />
                        <GalleryThumbs
                            isGalleryThumbsOpened = {this.state.galleryActive}
                            contextualMenu = {this.state.contextualMenu}
                            individualCar = {this.state.selectedIndividual} 
                            handleCloseGallery = {this.handleCloseGallery}
                            openVideo = {this.handleOpenVideo}
                            openImage = {this.handleOpenImage}
                            currentImageIndex = {this.state.currentMultimediaIndex}
                            isVideoOpened = {this.state.videoOpened}
                            isImageOpened = {this.state.imageOpened}
                        />
                        <AccessoriesThumbs
                            isGalleryThumbsOpened = {this.state.isAccesoriosOpened}
                            contextualMenu = {this.state.contextualMenu}
                            individualCar = {this.state.selectedIndividual} 
                            handleCloseGallery = {this.handleCloseGallery}
                            openImage = {this.handleOpenAccessoriesImage}
                            currentImageIndex = {this.state.currentAccessorieIndex}
                            isImageOpened = {this.state.accessoriesImageOpened}
                        />
                        <VideoGallery
                            isVideoOpened = {this.state.videoOpened}
                            VideoSrc = {this.state.videoSrc}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        <ImageGallery
                            isImageOpened = {this.state.imageOpened}
                            ImageSrc = {this.state.imageSrc}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        <ImageAccesorios
                            isImageOpened = {this.state.accessoriesImageOpened}
                            ImageSrc = {this.state.accessoriesImageSrc}
                            currentText = {this.state.accessoriesText}
                            currentUrl = {this.state.accessoriesUrl}
                            contextualMenu = {this.state.contextualMenu}
                        />
                        {
                            <div className={!this.state.showSurvey && this.state.showFlag ? 'survey-flag fade-in':'survey-flag fade-out'}>
                                <img src={calificanos} alt=''></img>
                            </div>
                        }
                        <SurveyBtn
                            handleShowSurvey = {this.handleShowSurvey}
                            showSurvey = {this.state.showSurvey}
                        />
                        <SurveyModal
                            showSurvey = {this.state.showSurvey}
                            handleShowSurvey = {this.handleShowSurvey}
                        />
                        
                        {this.state.isThreeActive ?
                            <Scene
                                isThreeActive = {this.state.isThreeActive}
                                currentAccessoriesSelected = {this.state.currentAccessoriesSelected}
                                currentColorSelected = {this.state.currentColorSelected}
                                selectedCar = {this.state.selectedIndividual}
                                handleLoad = {this.handleLoad}
                                currentIndividualAccessory = {this.state.currentIndividualAccessory}
                                isMobile={this.props.isMobile}
                                accessoriesMenuMobileOpened = {this.state.accessoriesMenuMobileOpened}
                            />:null
                        }
                        {
                            !this.props.isLoading && this.state.isInterior ?
                            <Viewer360
                                currentPanorama = { this.state.currentPanorama }
                                currentScene = { this.state.currentScene }
                                handleChangePano = { this.handleChangePano }
                                handleOpenBullet = {this.handleOpenInfoScreen}
                                renderFromMenu = {this.state.renderFromMenu}
                            />:<></>
                        }
                        {
                            this.state.isThreeActive && this.state.selectedIndividual ?
                            <AccesssoriesContainer
                                isThreeActive = {this.state.isThreeActive}
                                handleSelectedMenuElement = {this.handleSelectedMenuElement}
                                handleSetAccessoriesSelected = {this.handleSetAccessoriesSelected}
                                currentAccessoriesSelected = {this.state.currentAccessoriesSelected}
                                currentColorSelected = {this.state.currentColorSelected}
                                handleSetColor = {this.handleSetColor}
                                handleOpenTerms = {this.handleOpenTerms}
                                carSelected={this.state.selectedIndividual}
                                isInterior = {this.state.isInterior}
                            />:null
                        }
                        <Social/>
                        <div className='logo-ford-container'>
                            <img src={logoford}/>
                        </div>
                        <TopMenu
                            handleFullScreen={this.handleFullScreen}
                            handleAudio = {this.handleAudio}
                            isMuted = {this.state.isMuted}
                            handleOpenSurvey = {this.handleOpenSurveyPopup}
                        />
                        <CarMenu
                            btnSelectedIndex = {this.state.btnSelectedIndex}
                            handleBtnClick = {this.handleBtnClick}
                            isCarMenuOpened = {this.state.isCarMenuOpened}
                            selectedIndividual = {this.state.selectedIndividual}
                            handleContextualMenu = {this.handleContextualMenu}
                            contextualMenu = {this.state.contextualMenu}
                            handleSelectedMenuElement={this.handleSelectedMenuElement}
                            showLegalNote = {this.state.showLegalNote}
                            showMustangLegalNote = {this.state.showMustangLegalNote}
                            showEscapeLegalNote = {this.state.showEscapeLegalNote}
                            showExplorerLegalNote = {this.state.showExplorerLegalNote}
                            showBroncoLegalNote = {this.state.showBroncoLegalNote}
                        />
                        <Sidebar
                            isSidebarOpened={this.state.isSidebarOpened}
                            selectedCategory={this.state.selectedCategory}
                            selectedFamily={this.state.selectedFamily}
                            selectedIndividual={this.state.selectedIndividual}
                            handleSelectedCategory={this.handleSelectedCategory}
                            handleSelectedFamily={this.handleSelectedFamily}
                            handleSelectedIndividual={this.handleSelectedIndividual}
                            handleOpenBar={this.handleOpenBar}
                        />
                        <Info 
                            isInfoOpened = {this.state.isInfoOpened}
                            selectedIndividual = {this.state.selectedIndividual}
                            currentInfoImg = {this.state.currentInfoImg}
                            currentInfoText = {this.state.currentInfoText}
                            handleOpenInfoScreen = {this.handleOpenInfoScreen}
                        />
                        
                        <TermsConditions
                            termsOpened = {this.state.termsOpened}
                            handleOpenTerms = {this.handleOpenTerms}
                        />
                    </div>
                }

                {
                    this.state.hiddenVideo ?
                    null:
                    <div>
                        {this.state.videoStart ? <div className='skip-btn' onClick = {() => {this.handleCloseVideo()}}>Saltar video</div>:null}
                        <video id={"video"} className={this.state.videoStart ? 'fade-in':'fade-out'} playsInline preload='auto'>
                            <source src={video} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                        </video>
                    </div>
                }
                {
                    <div
                        className={
                        this.state.isLoading
                            ? "canvas-loading fade-in"
                            : "canvas-loading fade-out"
                        }
                    >
                        <svg
                        className="loader-circle-canvas"
                        viewBox="0 0 150 150"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <circle
                            className="internal-circle-canvas"
                            cx="75"
                            cy="75"
                            r="70"
                        ></circle>
                        </svg>
                        <svg
                        className="loader-circle-over-canvas"
                        viewBox="0 0 150 150"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <circle
                            className="internal-circle-over-canvas"
                            cx="75"
                            cy="75"
                            r="70"
                        ></circle>
                        </svg>
                    </div>
                    }
            </React.Fragment>
        )
    }
}

export default Canvas